type SessionLike =
  | { user?: { resource_access?: Record<string, { roles?: string[] }> } }
  | null
  | undefined;

export const getRolesFromSession = (session: SessionLike): string[] => {
  const clientId = process.env.NEXT_PUBLIC_KEYCLOAK_CLIENT_ID || "";
  return session?.user?.resource_access?.[clientId]?.roles || [];
};

export const sessionHasRole = (session: SessionLike, role: string): boolean =>
  getRolesFromSession(session).includes(role);
